module.exports = __webpack_public_path__ + "img/collection-diamondJewelryRosegold@2x.2a531d9.webp";